export default "__VITE_ASSET__C9B30Ukr__"